module.exports = __webpack_public_path__ + "static/media/ic_claim_b2_fisdom.cd858f1b.svg";